import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import { Link } from "react-router-dom"
import { Card, CardBody, Col, Container, Collapse, Media, Label, Input, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Select from 'react-select';
import _valid from "../../validations"
import { MDBDataTableV5 } from 'mdbreact';
import { SOLICITUD_ESTADOS, TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes"

const columns = [
    {
        label: "No",
        field: "id",
        sort: "asc",
        attributes: {
            'aria-controls': 'DataTable',
            'aria-label': 'No',
        },
        width: 200
    },
    {
        label: "Titulo",
        field: "titulo",
        sort: "asc",
        width: 200
    },
    {
        label: "Fecha Creacion",
        field: "fecha_creacion",
        sort: "asc",
        width: 200
    },
    {
        label: "Fecha Programada",
        field: "fecha_programada",
        sort: "asc",
        width: 200
    },
    {
        label: "Dias Trabajados",
        field: "horas",
        sort: "asc",
        width: 200
    },
    {
        label: "Solicitador por",
        field: "solicitante",
        sort: "asc",
        width: 200
    },
    {
        label: "Asignado a",
        field: "colaborador_nombre",
        sort: "asc",
        style: { font: { sz: "24", bold: true } },
        width: 200
    },
    {
        label: "Ubicación",
        field: "lugar_ubicacion_nombre",
        sort: "asc",
        width: 200
    },
    {
        label: "Área",
        field: "asignado_a_nombre",
        sort: "asc",
        width: 200
    },
    {
        label: "Estado",
        field: "estado",
        sort: "asc",
        width: 200
    },
    {
        label: "Aceptado por",
        field: "colaborador_que_acepta_seleccionado",
        sort: "asc",
        width: 200
    }
];

export default class reporte extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest();

        this.state = {
            tabla: { columns: columns, rows: [] },
            colapsar: true,
            modalAbierto: false,
            mostrarSpinner: true,
            idRegistroEliminar: null,

            fechaMin: null,
            fechaFin: null,
            solicitar_a: null,

            estado: null,
            lugar_ubicacion: null,
            tipo_solicitud: null,
            lista_Colaboradore: [],
            ubicaciones: [],
            tiposSolicitudes: [],
            departamentosAreas: [],
            listaColaboradoresSolicitud: [],
            mostrarTabla: false,
            tipo_colaborador: null,
            idSolicitud: null,

            titulo: null,
            fechaConcluido1: null,
            fechaConcluido2: null,
            tiempo: null,
            asignado: null
        }
        this.buscar = this.buscar.bind(this);
        this.actualizarValores = this.actualizarValores.bind(this);
        this.cambiosUbicacion = this.cambiosUbicacion.bind(this);
        this.cambiosSolicitud = this.cambiosSolicitud.bind(this);
        this.cambiosSolicitarA = this.cambiosSolicitarA.bind(this);
        this.cambiosColaborador = this.cambiosColaborador(this);
        this.cambiosColaboradorAsignado = this.cambiosColaboradorAsignado.bind(this);
        this.borrarFiltros = this.borrarFiltros.bind(this);
    }

    componentDidMount() {
        this.cargarListado();
        let id = null;
        id = this.apiRest.getLS('du').colaborador.id;
        if (this.apiRest.getRol()) {
            this.getDepartamentoArea();
        } else {
            this.obtenerDepartamentoLoggeado(id);
        }
    }

    obtenerDepartamentoLoggeado = (id) => {
        if (_valid(id)) {
            this.apiRest.get('/departamentoLoggeado/' + id).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ mostrarSpinner: false, departamentosAreas: this.formatoLabel(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }
    }

    getDepartamentoArea = () => {
        //obtener departamento
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ mostrarSpinner: false, departamentosAreas: this.formatoTexto(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    formatoLabel = valores => valores.data.map(i => ({ value: i.id_departamento, label: i.departamento }));
    formatoTexto = valores => valores.data.map(i => ({ value: i.id, label: i.texto_area }));
    formatoColaborador = valores => valores.data.map(i => ({ value: i.value, label: i.label }));

    actualizarValores = ({ target: { name, value } }) => {
        this.setState(estadoAnterior => ({
            ...estadoAnterior, [name]: value
        }));
    }

    cambiosUbicacion = lugar => {
        this.setState({ lugar_ubicacion: lugar });
    }

    cambiosSolicitarA = asignado => {
        this.setState({ solicitar_a: asignado });
        this.obtenerTipoSolicitud(asignado);
        this.obtenerListaColaboradores(asignado);
    }

    cambiosColaboradorAsignado = solicitud => {
        this.setState({ asignado: solicitud });
    }

    obtenerTipoSolicitud(departamentoArea) {
        if (_valid(departamentoArea)) {
            this.apiRest.get('/tipoSolicitudPorDepartamentoArea/' + departamentoArea.value).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ tiposSolicitudes: this.formatoSelect(resultado) });
                }
            });
        } else {
            this.setState({ mostrarSpinner: false, tiposSolicitudes: [] });
        }
    }

    obtenerListaColaboradores(departamentoArea) {
        if (_valid(departamentoArea)) {
            this.apiRest.get('/getColaboradorPorDepartamento/' + departamentoArea.value).then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ listaColaboradoresSolicitud: this.formatoColaborador(resultado) });
                }
            });
        } else {
            this.setState({ mostrarSpinner: false, listaColaboradoresSolicitud: [] });
        }
    }

    cambiosSolicitud = solicitud => {
        this.setState({ tipo_solicitud: solicitud });
    }

    //linea de cambio colaborador
    cambiosColaborador = colaborador => {
        this.setState({ tipo_colaborador: colaborador });
    }

    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));
    formatoSelectUbicacion = valores => valores.data.map(i => ({ value: i.id, label: i.ubicacion_texto }));

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });

        /*this.apiRest.get('/tipoSolicitud').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ mostrarSpinner: false, tiposSolicitudes: this.formatoSelect(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });*/

        if(this.apiRest.getRol()){
            this.apiRest.get('/ubicacion').then(resultado => {
                if (resultado.exitoso) {
                    this.setState({ mostrarSpinner: false, ubicaciones: this.formatoSelectUbicacion(resultado) });
                } else {
                    toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                }
            });
        }else{
            if (_valid(this.apiRest.getLS('idEmpresa'))) {
                this.apiRest.getUbicacion('/getUbicacion/').then(respuesta => {
                    if (respuesta.exitoso) {
                        this.setState({ mostrarSpinner: false, ubicaciones: this.formatoSelectUbicacion(respuesta) });
                    } else {
                        toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
                    }
                });
            }
        }

    }

    Estado = registro => {
        switch (registro.estado) {
            case 0:
                //no asignado
                return "No asignado"
            case 1:
                //asignado
                return "Asignado"
            case 2:
                //planificado
                return "Planificado"
            case 3:
                //concluido
                return "Concluido"
            case 4:
                //aceptado
                return "Aceptado"
            case 5:
                //rechazado
                return "Rechazado"
            case 6:
                //En proceso
                return "En proceso"
            default:
                console.log('vacio sin valor')
                break;
        }
    }

    Aceptado = registro => {
        let acepta = null;
        acepta = registro.colaborador_que_acepta_seleccionado;
        if (acepta != null) {
            return acepta.label;
        } else {
            console.log("vacio")
            return "";
        }
    }

    Solicitante = (registro) => {
        let solicitante = null;
        solicitante = registro.solicitante_seleccionado
        if (solicitante != null) {
            return solicitante.label;
        } else {
            console.log("vacio")
            return "";
        }
    }

    agregarAccionesRegistro = rows => {

        rows.forEach(
            registro => registro.estado = this.Estado(registro)
        );

        rows.forEach(
            registro => registro.colaborador_que_acepta_seleccionado = this.Aceptado(registro)
        );

        rows.forEach(
            registro => registro.solicitante = this.Solicitante(registro)
        );
        return { columns, rows };
    };

    getReport = () => {
        const {
            tabla
        } = this.state
        let array = null;
        if (_valid(tabla)) {
            array = tabla.rows
        }
        if (_valid(array)) {
            this.reporte(array)
        } else {
            toastr.error('Busque Primero la Informacion que quiere Exportar a Excel');
        }
    }

    //filtro normal
    filtrarDatos = async (filtro) => {
        this.apiRest.put('/solicitudFiltrar', filtro).then(respuesta => {
            if (respuesta.exitoso) {
                //console.log(respuesta.data)
                this.setState({ fechaMin: "" });
                this.setState({ fechaFin: "" });
                this.setState({ fechaConcluido1: "" });
                this.setState({ fechaConcluido2: "" });
                this.setState({ estado: "" });
                this.setState({ idSolicitud: "" });
                this.setState({ asignado: "" });
                this.setState({ tiempo: "" })
                this.borrarCampos();
                this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
            } else {
                this.props.history.push('/Timeout');
            }
        });
    }

    //reporte de solicitudes
    reporte = (datos) => {
        if (_valid(datos)) {
            const auth = this.apiRest.getLS('authUser');
            if (auth !== null) {
                const headers = {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.access },
                    responseType: 'blob',
                    body: JSON.stringify(datos ? datos : '')
                }
                fetch(process.env.REACT_APP_API_URL + "/reporteExcelSolicitud", headers).then(resp => {
                    if (resp.status >= 200 && resp.status < 300) {
                        resp.blob().then(blob => {
                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.style.display = "none";
                            a.href = url;
                            // the filename you want
                            a.download = "reporte.xlsx";
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                        });
                    } else if (resp.status === 401) {
                        this.props.history.push('/Timeout');
                    }
                });
            } else {
                toastr.error('Vaya! No loggeado, por favor intenta nuevamente.');
            }
        } else {
            toastr.error('No hay datos para procesar');
        }
    }

    //borrar los campos
    borrarCampos() {
        this.setState({ tipo_colaborador: "" });
        this.setState({ fechaConcluido1: "" });
        this.setState({ fechaConcluido2: "" });
        this.setState({ titulo: "" });
        this.setState({ fechaMin: null });
        this.setState({ fechaFin: null });
        this.setState({ estado: null });
        this.setState({ fechaConcluido: null });
        this.setState({ tipo_colaborador: null });
        this.setState({ idSolicitud: null });
        this.setState({ titulo: null });
        this.setState({ asignado: null });
        this.setState({ tiempo: null });
    }

    //filtrar colaborador
    fitrarColabodor = async (filtro) => {
        let array = []
        this.apiRest.put('/solicitudFiltrar', filtro).then(respuesta => {
            if (respuesta.exitoso) {
                toastr.success('Procesando solicitud');
                let objeto = []
                array = respuesta.data;
                array.forEach((e, indice) => {
                    if (e.colaborador_nombre.toLowerCase().includes(filtro.tipo_colaborador.toLowerCase())) {
                        objeto[indice] = e;
                    }
                });
                this.borrarCampos();
                this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(objeto) });
            } else {
                this.borrarCampos();
            }
        });
    }

    validador(filtro) {
        let verdad = false

        for (const property in filtro) {
            if (_valid(filtro[property])) {
                return verdad = true
            }
        }
        return verdad;
    }

    buscar = async () => {
        const {
            fechaMin,
            fechaFin,
            estado,
            solicitar_a,
            lugar_ubicacion,
            tipo_solicitud,
            tipo_colaborador,
            fechaConcluido1,
            fechaConcluido2,
            titulo,
            idSolicitud,
            tiempo,
            asignado
        } = this.state;

        this.setState({ mostrarTabla: true });
        let solicitar = null
        let lugar = null
        let tipo = null
        let titulo2 = null
        let colaborador = null
        if (solicitar_a !== null) {
            solicitar = solicitar_a.value
        } else if (lugar_ubicacion !== null) {
            lugar = lugar_ubicacion.value
        } else if (tipo_solicitud !== null) {
            tipo = tipo_solicitud.value
        } else if (titulo !== null) {
            titulo2 = titulo
        }
        
        if(_valid(asignado)){
            colaborador = asignado.value
        }
        const filtro = {
            fechaMin,
            fechaFin,
            fechaConcluido1,
            estado,
            fechaConcluido2,
            solicitar,
            lugar,
            tipo,
            titulo2,
            idSolicitud,
            tipo_colaborador,
            tiempo,
            colaborador
        }

        if (this.validador(filtro)) {
            this.filtrarDatos(filtro);
        } else {
            console.log("vacio");
            toastr.error('Seleccione un filtro para buscar por favor');
            this.borrarCampos();
            let v = []
            this.setState({ mostrarSpinner: false, tabla: v.data });
        }
    }

    colapsar() {
        this.setState(estadoAnterior => ({ colapsar: !estadoAnterior.colapsar }));
    }

    borrarFiltros = () => {
        this.setState({
            fechaFin: null, fechaMin: null,
            solicitar_a: null,
            fechaConcluido2: null, fechaConcluido1: null,
            lugar_ubicacion: null,
            estado: null,
            tipo_solicitud: null,
            tipo_colaborador: null,
            tiempo: null,
            asignado: null,
            idSolicitud: null,
            titulo: null
        });

        this.setState({
            fechaFin: '', fechaMin: '',
            solicitar_a: '',
            fechaConcluido2: '', fechaConcluido1: '',
            lugar_ubicacion: '',
            estado: '',
            tipo_solicitud: '',
            tipo_colaborador: '',
            tiempo: '',
            asignado: '',
            idSolicitud: '',
            titulo: ''
        });
    }

    render() {
        const {
            colapsar,
            mostrarTabla,
            mostrarSpinner,
            tabla,
            fechaMin,
            fechaFin,
            estado,
            lugar_ubicacion,
            tipo_solicitud,
            solicitar_a,
            departamentosAreas,
            tiposSolicitudes,
            ubicaciones,
            tipo_colaborador,
            registro,
            titulo,
            fechaConcluido1,
            fechaConcluido2,
            idSolicitud,
            tiempo,
            asignado,
            listaColaboradoresSolicitud
        } = this.state;
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Mesa de Servicio" breadcrumbItem="Reportes de Solicitudes" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <Link onClick={() => this.colapsar()} className="text-dark" to="#">
                                            <div className="p-4">
                                                <Media className="d-flex align-items-center">
                                                    <div className="me-3">
                                                        <i className="uil uil-receipt text-primary h2"></i>
                                                    </div>
                                                    <div className="flex-1 overflow-hidden">
                                                        <h5 className="font-size-16 mb-1">Reporte</h5>
                                                        <p className="text-muted text-truncate mb-0">Por favor, seleccione una opci&oacute;n.</p>
                                                    </div>
                                                    <i className="mdi mdi-chevron-up accor-down-icon font-size-24"></i>
                                                </Media>
                                            </div>
                                        </Link>
                                        <Collapse isOpen={colapsar}>
                                            <Row>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaMin" className="form-label">
                                                        Fecha Creaci&oacute;n Inicio
                                                    </Label>
                                                    <Input
                                                        value={fechaMin}
                                                        onChange={this.actualizarValores}
                                                        name="fechaMin"
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaFin" className="form-label">
                                                        Fecha Creaci&oacute;n Fin
                                                    </Label>
                                                    <Input
                                                        value={fechaFin}
                                                        onChange={this.actualizarValores}
                                                        name="fechaFin"
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaConcluido" className="form-label">
                                                        Fecha Concluido Inicio
                                                    </Label>
                                                    <Input
                                                        value={fechaConcluido1}
                                                        onChange={this.actualizarValores}
                                                        name="fechaConcluido1"
                                                        type="date"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="fechaConcluido2" className="form-label">
                                                        Fecha Concluido Fin
                                                    </Label>
                                                    <Input
                                                        value={fechaConcluido2}
                                                        onChange={this.actualizarValores}
                                                        name="fechaConcluido2"
                                                        type="date"
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={3}>
                                                    <Label htmlFor="lugar_ubicacion" className="form-label">
                                                        Ubicación
                                                    </Label>
                                                    <Select
                                                        name="lugar_ubicacion"
                                                        options={ubicaciones}
                                                        value={lugar_ubicacion}
                                                        onChange={this.cambiosUbicacion}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="estado" className="form-label">
                                                        Estado
                                                    </Label>
                                                    <select
                                                        value={estado}
                                                        onChange={this.actualizarValores}
                                                        name="estado"
                                                        className="form-control"
                                                    >
                                                        {SOLICITUD_ESTADOS.map(objeto => <option key={objeto.value} value={objeto.value}>{objeto.label}</option>)}
                                                    </select>
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="solicitar_a" className="form-label">
                                                        Departamento/Área
                                                    </Label>
                                                    <Select
                                                        name="solicitar_a"
                                                        options={departamentosAreas}
                                                        value={solicitar_a}
                                                        onChange={this.cambiosSolicitarA}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="tipo_solicitud" className="form-label">
                                                        Tipo de Solicitud
                                                    </Label>
                                                    <Select
                                                        name="tipo_solicitud"
                                                        options={tiposSolicitudes}
                                                        value={tipo_solicitud}
                                                        onChange={this.cambiosSolicitud}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={3}>
                                                    <Label htmlFor="tipo_colaborador" className="form-label">
                                                        Asignado a:
                                                    </Label>
                                                    <Input
                                                        value={tipo_colaborador}
                                                        onChange={this.actualizarValores}
                                                        name="tipo_colaborador"
                                                        type="text"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="titulo" className="form-label">
                                                        Titulo:
                                                    </Label>
                                                    <Input
                                                        value={titulo}
                                                        onChange={this.actualizarValores}
                                                        name="titulo"
                                                        type="text"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="idSolicitud" className="form-label">
                                                        Numero de solicitud:
                                                    </Label>
                                                    <Input
                                                        value={idSolicitud}
                                                        onChange={this.actualizarValores}
                                                        name="idSolicitud"
                                                        type="number"
                                                        min="1"
                                                    />
                                                </Col>
                                                <Col lg={3}>
                                                    <Label htmlFor="asignado" className="form-label">
                                                        Realizado por:
                                                    </Label>
                                                    {
                                                    /*<Input
                                                        value={asignado}
                                                        onChange={this.actualizarValores}
                                                        name="asignado"
                                                        type="text"
                                                    /> */
                                                    }
                                                    <Select
                                                        name="asignado"
                                                        options={listaColaboradoresSolicitud}
                                                        value={asignado}
                                                        onChange={this.cambiosColaboradorAsignado}
                                                        className="basic-single"
                                                        classNamePrefix="select"
                                                        placeholder="Selecciona.."
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        noOptionsMessage={() => "No hay más opciones"}
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col lg={3}>
                                                    <Label htmlFor="tiempo" className="form-label">
                                                        Tiempo:
                                                    </Label>
                                                    <Input
                                                        value={tiempo}
                                                        onChange={this.actualizarValores}
                                                        name="tiempo"
                                                        type="number"
                                                        step="0.01" min="0" max="100"
                                                    />
                                                </Col>
                                            </Row>
                                            <p />
                                            <Row>
                                                <Col>
                                                    <MDBBtn color="success" onClick={this.buscar}>
                                                        <MDBIcon icon="fas fa-search" />{' '}
                                                        Buscar
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn color="success" onClick={this.getReport}>
                                                        <MDBIcon icon="fas fa-book" />{' '}
                                                        Generar Reporte en Excel
                                                    </MDBBtn>
                                                    {' '}
                                                    <MDBBtn className="waves-effect" color="warning" onClick={this.borrarFiltros}>
                                                        <MDBIcon icon="fas fa-trash-alt" />{' '}
                                                        Borrar Filtros
                                                    </MDBBtn>
                                                </Col>
                                            </Row>
                                            <p />
                                        </Collapse>
                                        {
                                            mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <Row>
                                            <Col>
                                                <div>
                                                    {' '}
                                                    {
                                                        mostrarTabla &&
                                                        <div className="table-responsive">
                                                            <MDBDataTableV5
                                                                scrollX
                                                                striped
                                                                bordered
                                                                id="solicitudes"
                                                                hover
                                                                entriesOptions={[10, 50, 100]}
                                                                entries={5}
                                                                pagesAmount={4}
                                                                data={tabla}
                                                                pagingTop
                                                                searchTop
                                                                searchBottom={false}
                                                                noRecordsFoundLabel="No hay datos."
                                                                searchLabel="Buscar.."
                                                            />
                                                        </div>
                                                    }
                                                </div>
                                            </Col>
                                        </Row>

                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} className="text-end">
                                <MDBBtn color="danger" onClick={() => { this.props.history.replace('/dashboard') }}>
                                    <MDBIcon icon="fas fa-arrow-left" />{' '}
                                    Regresar
                                </MDBBtn>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}